import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_ALREADY_USED',
    statusCode: 400,
    message: {
        en: 'Already Used',
    },
} as CustomErrorType;